import React from 'react';
import { useTranslation } from 'react-i18next';
import { maxMobileSize, savedJobOptions } from '../../../utils/constants';
import AppliedJobCard from '../Cards/AppliedJobCard/AppliedJobCard';
import { useWindowSize } from '../../../utils/hooks';
import JobCardSkeleton from '../Skeletons/JobCardSkeleton';
import EmptyList from '../EmptyList/EmptyList';
import Table from '../Table/Table';
import { savedJobsConstant } from './helpers/savedJobs';
import { Menu } from '../Form/Menu/Menu';

function SavedJobsList(props) {
  const { jobsData, pendingFetch, handleJobOptions } = props;

  const { t } = useTranslation();
  const size = useWindowSize();

  if ((!Array.isArray(jobsData) || jobsData.length === 0) && pendingFetch === false) {
    return (
      <EmptyList
        mainTitle={t('dashboard.jobs.emptylist.savednojobs')}
        secondaryTitle={t('dashboard.jobs.emptylist.savedsecondary')}
        buttonTitle={t('dashboard.jobs.emptylist.buttonlabel')}
        routeForNavigation="/dashboard/jobs"
      />
    );
  }

  return size.width > maxMobileSize ? (
    <Table cols={savedJobsConstant(t, handleJobOptions)} data={jobsData} pendingFetch={pendingFetch} />
  ) : (
    <div data-testid="mobile" className="d-flex flex-column gap-2 mb-3">
      {/* eslint-disable-next-line no-nested-ternary */}
      {pendingFetch ? (
        Array.from({ length: 5 }, (v, k) => k)
          // eslint-disable-next-line react/no-array-index-key
          .map((_, idx) => <JobCardSkeleton key={idx} qty={6} />)
      ) : jobsData?.length === 0 || !Array.isArray(jobsData) ? (
        <h6>{t('dashboard.jobs.appliedlist.nojobs')}</h6>
      ) : (
        jobsData.map((item) => (
          <Menu
            options={savedJobOptions(t, item)}
            key={item?.JobId}
            onMenuSelect={(action) => handleJobOptions(action, item?.JobId)}
            isArrowIcon={false}
            classes="d-flex flex-column"
          >
            <AppliedJobCard
              key={item.JobId}
              job={item.Job}
              jobId={item.JobId}
              cretedDate={item.CreatedDate}
              status={item.Status}
              dots
            />
          </Menu>
        ))
      )}
    </div>
  );
}

export default SavedJobsList;
